import {
  FormControlLabel,
  FormHelperText,
  Radio,
  RadioGroup,
} from "@mui/material";
import { ChangeEvent, FC, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { BulkRecalculatePriceSelectionScope } from "@ryde/shared";

import { BulkRecalculateSelectionPanelStyled } from "./bulk-recalculate-options.styled";
import {
  BulkRecalculateRateType,
  IBulkRecalculateSelectionCounts,
} from "./bulk-recalculate-selection.models";
import { getBulkRecalculateSelectionRadioOptions } from "./bulk-recalculate-selection.utils";

interface IBulkRecalculateSelectionRadioGroupProps {
  rateType: BulkRecalculateRateType;
  selectionScope: BulkRecalculatePriceSelectionScope;
  onSelectionScopeChange: (event: ChangeEvent<HTMLInputElement>) => void;
  selectionCounts: IBulkRecalculateSelectionCounts;
}

export const BulkRecalculateSelectionRadioGroup: FC<
  IBulkRecalculateSelectionRadioGroupProps
> = ({ rateType, selectionScope, onSelectionScopeChange, selectionCounts }) => {
  const { t } = useTranslation();

  const selectionOptions = useMemo(
    () => getBulkRecalculateSelectionRadioOptions(rateType, selectionCounts, t),
    [rateType, selectionCounts, t],
  );

  return (
    <BulkRecalculateSelectionPanelStyled>
      <RadioGroup value={selectionScope} onChange={onSelectionScopeChange}>
        {selectionOptions.map(option => (
          <div className="selection-radio-option" key={option.value}>
            <FormControlLabel
              value={option.value}
              control={<Radio />}
              disabled={option.disabled}
              label={
                <div className="selection-radio-label">
                  <span className="radio-label">{option.label}</span>
                  <FormHelperText>{option.helperText}</FormHelperText>
                </div>
              }
            />
          </div>
        ))}
      </RadioGroup>
    </BulkRecalculateSelectionPanelStyled>
  );
};
